import request from "@/utils/request";

let domain = '';
if(window.location.host.includes('-p')){
	domain = 'https://p.landui.com/';
}else if(window.location.host.includes('.st')){
	domain = 'https://www.st.landui.cn/';
}else if(window.location.host.includes('dev') || window.location.host.includes('localhost')){
	domain = 'http://www.zj.dev.landui.cn/';
}else{
	domain = 'https://www.landui.com/';
}

export function webMsg() {
	return request({
		url: domain + 'user/index/webMsg',
		method: 'GET'
	})
}

export function captchaFetch() {
  return request({
    url: 'api/common/captcha',
    method: 'get'
  })
}

export function registerSendCode(param) {
  return request({
    url: 'api/users/register/sendsmscode',
    method: 'post',
    data: param
  })
}

export function registerCheck(param) {
  return request({
    url: 'api/users/register/check',
    method: 'post',
    data: param
  })
}

export function register(param) {
  return request({
    url: 'api/users/register/user',
    method: 'post',
    data: param
  })
}

export function wechatStatus() {
  return request({
    url: 'api/users/register/wechatStatus',
    method: 'get'
  })
}

export function wechatBind() {
  return request({
    url: 'api/users/register/wechat',
    method: 'get'
  })
}

export function getuserhasproduct(param) {
  return request({
    url: 'api/users/getuserhasproduct',
    method: 'post',
	data: param
  })
}

export function accountcheck(param) {
  return request({
    url: 'api/users/login/accountcheck',
    method: 'post',
	data: param
  })
}

export function loginAccount(param) {
  return request({
    url: 'api/users/login/account',
    method: 'post',
    data: param
  })
}

export function loginMobile(param) {
  return request({
    url: 'api/users/login/mobile',
    method: 'post',
    data: param
  })
}

export function loginSendCode(param) {
  return request({
    url: 'api/users/login/sendsmscode',
    method: 'post',
    data: param
  })
}

export function wechatlogin() {
  return request({
    url: 'api/users/wechat/oauth',
    method: 'get'
  })
}

export function qqlogin() {
  return request({
    url: 'api/users/qq/oauth',
    method: 'get'
  })
}

export function quicklogin(param) {
  return request({
    url: '/api/users/bind',
    method: 'post',
    data: param
  })
}

export function checkAccount(param) {
  return request({
    url: 'api/users/forgetpwd/checkaccount',
    method: 'post',
    data: param
  })
}

export function sendSmscode(param) {
  return request({
    url: 'api/users/forgetpwd/sendsmscode',
    method: 'post',
    data: param
  })
}

export function checkMobilecode(param) {
  return request({
    url: 'api/users/forgetpwd/checkmobilecode',
    method: 'post',
    data: param
  })
}

export function sendEmailcode(param) {
  return request({
    url: 'api/users/forgetpwd/sendemailcode',
    method: 'post',
    data: param
  })
}

export function checkEmailcode(param) {
  return request({
    url: 'api/users/forgetpwd/checkemailcode',
    method: 'post',
    data: param
  })
}

export function checkQuescode(param) {
  return request({
    url: 'api/users/forgetpwd/checkquestioncode',
    method: 'post',
    data: param
  })
}

export function resetPwd(param) {
  return request({
    url: 'api/users/forgetpwd/resetpwd',
    method: 'post',
    data: param
  })
}

export function appealStep() {
  return request({
    url: 'api/users/appeal/step',
    method: 'get'
  })
}

export function appealSmscode(param) {
  return request({
    url: 'api/users/appeal/sendsmscode',
    method: 'post',
	data: param
  })
}

export function appealAccount(param) {
  return request({
    url: 'api/users/appeal/checkaccount',
    method: 'post',
    data: param
  })
}

export function appealAuth(param) {
  return request({
    url: 'api/users/appeal/authaccount',
    method: 'post',
    data: param
  })
}

export function appealInfo(param) {
  return request({
    url: 'api/users/appeal/proofinfo',
    method: 'post',
    data: param
  })
}

export function appealOrder(param) {
  return request({
    url: 'api/users/appeal/orderstatus?orderId='+param,
    method: 'get'
  })
}

export function appealVerify() {
  return request({
    url: 'api/users/appeal/apiauthverify',
    method: 'get'
  })
}

export function appealPay(param) {
  return request({
    url: domain + 'api/financial/payCashierAjaxQrcode?orderid='+param.orderid+'&id='+param.id,
    method: 'get'
  })
}

export function isLogin() {
  return request({
    url: 'api/users/user/data',
    method: 'get'
  })
}

export function apiExit(param) {
  return request({
    url: 'alone/logout',
    method: 'post',
    data: param
  })
}



